import Vue from 'vue'

const els = document.querySelectorAll("[id^='video-trigger--']")
if (els != null) {
  els.forEach((el) => {
    var vm = new Vue({
      data: () => {
        return {
          videoIsOpen: false,
          videoUrl: null,
          videoTitle: null,
          youtubeOpts: {
            autoplay: 1,
            cc_load_policy: 1,
            color: null,
            controls: 1,
            disablekb: 0,
            enablejsapi: 0,
            end: null,
            fs: 1,
            h1: null,
            iv_load_policy: 1,
            list: null,
            listType: null,
            loop: 0,
            modestbranding: 1,
            origin: null,
            playlist: null,
            playsinline: null,
            rel: 0,
            showinfo: 1,
            start: 0,
            wmode: 'transparent',
            theme: 'dark'
          },
          vimeoOpts: {
            api: false,
            autopause: true,
            autoplay: true,
            byline: true,
            callback: null,
            color: null,
            height: null,
            loop: false,
            maxheight: null,
            maxwidth: null,
            player_id: null,
            portrait: true,
            title: true,
            width: null,
            xhtml: false
          }
        }
      },
      delimiters: ['[[', ']]'],
      methods: {
        toggleOpen () {
          this.videoIsOpen = !this.videoIsOpen
        },
        getQueryString (obj) {
          let url = ''
          for (var key in obj) {
            url += key + '=' + obj[key] + '&'
          }
          return url.substr(0, url.length - 1)
        }
      },
      computed: {
        fullVideoUrl () {
          let url = ''
          const yt = this.videoUrl.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/)
          const vimeo = this.videoUrl.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/)
          const queryArgs = yt
            ? this.youtubeOpts
            : vimeo
              ? this.vimeoOpts
              : null
          if (yt) {
            url = '//www.youtube.com/embed/' + yt[7] + '?' + queryArgs
          } else if (vimeo) {
            url = '//player.vimeo.com/video/' + vimeo[3] + '?' + queryArgs
          }
          return url
        }
      },
      watch: {
        videoIsOpen: {
          handler: function (val) {
            if (this.videoIsOpen) {
              document.documentElement.classList.add('is-clipped')
            } else {
              document.documentElement.classList.remove('is-clipped')
            }
            this.$nextTick(() => {
              if (typeof this.$refs.closeBtn !== 'undefined') {
                this.$refs.closeBtn.focus()
              }
            })
          },
          deep: true
        }
      },
      beforeMount () {
        this.videoUrl = this.$el.attributes['data-video-url'].value
        this.videoTitle = this.$el.attributes['data-video-title'].value
      }
    })
    vm.$mount(el)
  })
}
